
<div style="width:98%">
<ng2-pdfjs-viewer pdfSrc="{{url}}"></ng2-pdfjs-viewer>
</div>


